import { useMemo, useState } from 'react';
import useChat from 'hooks/chat/useChat.hook';
import ContactConversationItem from 'views/chat/components/items/ContactConversationItem.component';
import ChatHeaderActionsSection from 'views/chat/components/sections/ChatHeaderActionsSection.component';
import CreateCommentDialog from '../dialogs/CreateCommentDialog.component';
import ReassignedConversationDialog from '../dialogs/ReassignedConversationDialog.component';
import NeoButtonSplit from 'design/design_components/neo/button/NeoButtonSplit.base';
import NeoButtonMain from 'design/design_components/neo/button/NeoButtonMain.base';
import MENU from 'consts/menu.consts';
import { useHistory } from 'react-router-dom';

const ConversationInfo = (props) => {
  const chat = useChat();
  const history = useHistory();

  const contact = chat.selected.conversation && <ContactConversationItem name={chat.selected.conversation?.contact?.name} alias={chat.selected.conversation.contact?.alias} phone={chat.selected.conversation?.contact?.phone} />;

  const actions = (!chat.selected.conversation?.isFinished && !chat.selected.conversation?.isReassigned) && (() => {
    const [showReassignedDialog, setShowReassignedDialog] = useState(false);
    const [showCreateCommentDialog, setShowCreateCommentDialog] = useState(false);

    const ButtonsSplit = () => {
      const model=[];
      if(props.render?.actions?.finalize?.isRender !== false) {
        model.push({
          label: 'Finalizar conversación', 
          icon: 'pi pi-power-off', 
          command: () => setShowCreateCommentDialog(true)
        });
      }

      return <NeoButtonSplit
        label="Reasignar"
        icon="pi pi-users"
        onClick={() => setShowReassignedDialog(true)}
        model={model}>
      </NeoButtonSplit>;
    }
    
    const ButtonReassigned = () => {
      return <>
        <NeoButtonMain
          type="button"
          icon="pi pi-users"
          label="Reasignar"
          onClick={() => setShowReassignedDialog(true)}
        />
      </>
    }

    const ButtonFinalize = () => {
      return <>
        <NeoButtonMain
          type="button"
          icon="pi pi-power-off"
          label="Finalizar conversación"
          onClick={() => setShowCreateCommentDialog(true)}
        />
      </>
    }

    const ButtonReopen = () => {
      return <>
        <NeoButtonMain
          type="button"
          icon="fa fa-comment-medical"
          label="Reabrir conversación"
          onClick={() => {
            const { contact } = chat.selected.conversation;
            const { id } = contact;
            history.push(`${MENU.ADMIN.CONVERSATIONS.START_CONVERSATION.BASE}/${id}`);
          }}
        />
      </>
    }

    const ButtonClose = () => {
      return <>
        <NeoButtonMain
          type="button"
          icon="pi pi-times"
          label="Cerrar conversación"
          onClick={chat.closeConversation}
        />
      </>
    }

    const chatHeaderActionsComponents = useMemo(() => {
      const buttons = [
        ButtonsSplit, 
        (props.render?.actions?.reopen?.isRender !== false) && ButtonReopen,
        (props.render?.actions?.reassign?.isRender !== false) && ButtonReassigned,
        (props.render?.actions?.close?.isRender !== false) && ButtonClose,
        (props.render?.actions?.finalize?.isRender !== false) && ButtonFinalize
      ];
      return buttons;
    }, [props.render])

    return (<>
      <ChatHeaderActionsSection
        actions={chatHeaderActionsComponents} 
      />
      <ReassignedConversationDialog
        line={chat.selected.line}
        conversation={chat.selected.conversation}
        visible={showReassignedDialog}
        visibleSetter={setShowReassignedDialog}
        onHide={() => { }}
        onSubmit={chat.reassignedConversation}
      />
      <CreateCommentDialog
        visible={showCreateCommentDialog}
        visibleSetter={setShowCreateCommentDialog}
        onHide={() => { }}
        onSubmit={chat.finishConversation}
        title="Finalizar conversación"
        description="Ingresa un comentario interno final sobre esta conversación. 
        Recuerda que al finalizarla no tendrás acceso nuevamente a esta"
        placeholder="Añade un comentario de cierre:"
      />
    </>)
  })();

  return (
    <div className={`${props.component.name}__conversation-info`}>
      {contact}
      {actions}
    </div>
  );
}

export default ConversationInfo;